<div class="documents-container">
  <div class="header">
    {{ 'profile.documents' | translate }}
  </div>

  <div class="phone-filtration-btn-container">
    <libero-button
      label="{{ 'global.buttons.filterButton' | translate }}"
      btnClasses="btn--icon"
      svgIcon="chevron-down"
      [svgClass]="phoneFiltersToggled ? {'transform': 'rotate(180deg)'} : {}"
      [iconWidth]="18"
      (click)="toggleFiltration()"
      data-cy="phone-filtration-btn-container"
    ></libero-button>
  </div>

  <div class="filtrations-checkboxes " [ngClass]="{ 'filtrations-checkboxes--phone-toggled': phoneFiltersToggled }">
    @if (!searchApiDataError) {
      <div class="searchbox-container">
        <libero-string-searchbar [formName]="searchName" data-cy="filtration-searchbar-container"></libero-string-searchbar>
      </div>
    }

    <libero-documents-date-picker
      [fromControl]="dateFrom"
      [toControl]="dateTo"
    ></libero-documents-date-picker>
  </div>

  <div class="category-switch">
    <div
      class="switch-item"
      [ngClass]="{ 'switch-item--active': categorySelected === availableUiCategories.LISTINGS }"
      (click)="selectCategory(availableUiCategories.LISTINGS)"
      data-cy="document-category-switch-listenings"
      (keydown.space)="selectCategory(availableUiCategories.LISTINGS)"
      (keydown.enter)="selectCategory(availableUiCategories.LISTINGS)"
      tabindex="0"
      >
      {{ 'documents.listing' | translate }}
    </div>
    <div
      class="switch-item"
      [ngClass]="{ 'switch-item--active': categorySelected === availableUiCategories.OTHER }"
      (click)="selectCategory(availableUiCategories.OTHER)"
      data-cy="document-category-switch-other"
      (keydown.space)="selectCategory(availableUiCategories.OTHER)"
      (keydown.enter)="selectCategory(availableUiCategories.OTHER)"
      tabindex="0"
      >
      {{ 'documents.other' | translate }}
    </div>
  </div>

  @if (!preloader) {
    <div class="documents-list" >
      <hr class="divider">
      @if (documents.length > 0) {
        @for (document of documents | paginate: paginationConfig; track $index) {
          <div
            class="document-list-item"
            (click)="saveFile(document)"
            (keydown.space)="saveFile(document)"
            (keydown.enter)="saveFile(document)"
            tabindex="0"
            >
            <div class="row">
              <div class="col-2 col-md-1 my-auto">
                <svg-icon src="assets/icons/document.svg" [svgStyle]="{ 'width.px': 18 }"></svg-icon>
              </div>
              <div class="col-8 col-md-10 ">
                <div class="row">
                  <div class="col-12 col-md-9 document-header" data-cy="document-header">
                    {{ document.name }}
                  </div>
                  <div class="col-12 col-md-3 document-date">
                    {{ document.date | date:'d. M. y' }}
                  </div>
                </div>
              </div>
              <div class="col-2 col-md-1 my-auto text-end">
                <svg-icon src="assets/icons/chevron-down.svg" [svgStyle]="{ 'height.px': 15, 'transform': 'rotate(270deg)' }"></svg-icon>
              </div>
            </div>
          </div>
          <hr class="divider">
        }
      } @else {
        <div class="no-data-container">
          {{ 'global.error.noData' | translate }}
        </div>
      }
    </div>
    @if (documents.length > 0) {
      <pagination-template #p="paginationApi" class="pagination-custom-control" [id]="paginationConfig.id!">
        <div class="pagination-arrow pagination-previous " [ngClass]="{ 'pagination-arrow--inactive': !prevPageAvailable() }">
          <a
            (click)="loadPrevPage()"
            (keydown.space)="loadPrevPage()"
            (keydown.enter)="loadPrevPage()"
            tabindex="0"
            >
            <svg-icon src="assets/icons/chevron-down.svg" [svgStyle]="{ 'width.px':18, 'transform': 'rotate(90deg)' }"></svg-icon>
          </a>
        </div>
        @for (page of p.pages; track page.value) {
          <div [class.current]="p.getCurrent() === page.value">
            @if (p.getCurrent() !== page.value) {
              <a
                (click)="goToPage(page.value)"
                class="inactive-page"
                (keydown.space)="goToPage(page.value)"
                (keydown.enter)="goToPage(page.value)"
                tabindex="0"
                >
                <span>{{ page.label }}</span>
              </a>
            }
            @if (p.getCurrent() === page.value) {
              <div class="current-page">
                <span>{{ page.label }}</span>
              </div>
            }
          </div>
        }
        <div class="pagination-arrow pagination-next " [ngClass]="{ 'pagination-arrow--inactive': !nextPageAvailable() }" data-cy="documents-next-page">
          <a
            (click)="loadNextPage()"
            (keydown.space)="loadNextPage()"
            (keydown.enter)="loadNextPage()"
            tabindex="0"
            >
            <svg-icon src="assets/icons/chevron-down.svg" [svgStyle]="{ 'width.px':18, 'transform': 'rotate(270deg)' }"></svg-icon>
          </a>
        </div>
      </pagination-template>
    }
  } @else {
    <libero-preload-spinner></libero-preload-spinner>
  }
</div>

@if (generatingLinkPreloader) {
  <div class="preloader-overlay">
    <div class="preloader-overlay-background"></div>
    <libero-preload-spinner></libero-preload-spinner>
  </div>
}